"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchClosestMediaRegion = void 0;
const streem_logger_1 = require("./streem_logger");
const AWS_REGION_URL = 'https://nearest-media-region.l.chime.aws/';
const TIMEOUT_MS = 5000;
const fetchAWSRegion = () => {
    return fetch(AWS_REGION_URL, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        signal: AbortSignal.timeout(TIMEOUT_MS),
    });
};
// packages/api has its own request retry logic for calls to Streem services, but it's not exported
const retryRequest = (maxRetries, retryFn, requestName) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let retries = 0;
    while (retries < maxRetries) {
        try {
            const response = yield retryFn();
            if (response.ok) {
                return response;
            }
            else {
                streem_logger_1.streemLogger.warn(`Fetch call failed for ${requestName},attempt: ${retries + 1}`, {
                    status: response.status,
                });
                retries++;
            }
        }
        catch (err) {
            let errorMessage = '';
            if (err.name === 'TimeoutError') {
                errorMessage = `Fetch call timed out for ${requestName}, attempt: ${retries + 1}`;
            }
            else if (err.name === 'AbortError') {
                errorMessage = `Fetch call aborted for ${requestName}, attempt: ${retries + 1}`;
            }
            else if (err.name === 'TypeError') {
                errorMessage = `AbortSignal.timeout() method is not supported for ${requestName}, attempt: ${retries + 1}`;
            }
            else {
                errorMessage = `Fetch call failed for ${requestName}, attempt: ${retries + 1}`;
            }
            streem_logger_1.streemLogger.warn(errorMessage, {
                errorMessage: err.message,
                errorName: (_a = err.name) !== null && _a !== void 0 ? _a : 'undefined',
            });
            retries++;
        }
    }
    throw new Error(`Failed to fetch ${requestName} after ${maxRetries} retries`);
});
const fetchClosestMediaRegion = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield retryRequest(2, fetchAWSRegion, 'closest AWS region');
        const body = yield response.json();
        return body.region;
    }
    catch (err) {
        streem_logger_1.streemLogger.error('Failed to fetch closest region', {
            errorMessage: err.message,
            stack: err.stack,
        });
        return undefined;
    }
});
exports.fetchClosestMediaRegion = fetchClosestMediaRegion;
//# sourceMappingURL=fetch_closest_media_region.js.map